import { ActionTypes } from '../actions';

const initialState = {
  all: [],
};

const ContributorsReducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.FETCH_CONTRIBUTORS:
      return { all: action.payload };
    default:
      return state;
  }
};

export default ContributorsReducer;
